import { DataSecurityApplicationStatus } from './DataSecurityApplicationStatus';
import { DataSecurityMonitorType } from '.';

export type DataSecurityMonitorReference = {
	monitorName: string;
	monitorTypeId: DataSecurityMonitorType;
};

export enum DataSecurityApplicationType {
	ConnectedApplication = 'ConnectedApplication',
	ExternalClientApplication = 'ExternalClientApplication'
}

export type DataSecurityApplicationBase = {
	activeTokens?: number;
	appType?: DataSecurityApplicationType;
	classification?: string | null;
	deletedOn?: string;
	description?: string;
	installed: boolean;
	name: string;
	label?: string;
	ownerId?: number | null;
	stakeholderIds?: number[];
	stakeholderGroupId?: number | null;
	activityPeriod: number;
	monitors: DataSecurityMonitorReference[];
	status: DataSecurityApplicationStatus;
};

export type DataSecurityApplication = DataSecurityApplicationBase & {
	applicationId: number;
	integrationUser: string;
};

export type DataSecurityApplicationReference = Omit<DataSecurityApplication, 'applicationId'>;

export type UpdateDataSecurityApplicationReferenceRequest = Partial<DataSecurityApplicationReference> & {
	applicationId: number;
};
